/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 4/13/2016
 * Time: 11:49 AM
 */
import keymirror from 'keymirror';

const Actions = keymirror({
  BRANCHES_LOADED: null,
  BRANCH_SEARCH_STARTED: null,
  BRANCH_SEARCH_FAILED: null,
  EMPLOYEES_LOADED: null,
  EMPLOYEES_CONFLICTS_LOADED: null,
  EMPLOYEE_SEARCH_VALUE_CHANGED: null,
  BRANCH_SEARCH_VALUE_CHANGED: null,
  NEW_EMPLOYEE_SELECTED: null,
  EDIT_EMPLOYEE_SELECTED: null,
  EMPLOYEE_SEARCH_STARTED: null,
  EMPLOYEE_SEARCH_FAILED: null,
  EMPLOYEE_UPDATE_STARTED: null,
  EMPLOYEE_UPDATE_SUCCESSFUL: null,
  EMPLOYEE_UPDATE_CANCELED: null,
  EMPLOYEE_UPDATE_ERROR: null,
  EMPLOYEE_UPDATE_FAILED: null,
  EMPLOYEE_SELECTED: null,
  EMPLOYEE_DESELECTED: null,
  EMPLOYEE_LOGGED_IN: null,
  EMPLOYEE_LOGIN_STARTED: null,
  ENABLE_EDIT: null
});

export default Actions;



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/constants/Actions.js
 **/